import React, { Component } from 'react'
import { withApollo } from '@apollo/client/react/hoc'
import { Row, Col, Card, Button } from 'antd'
import { FormattedMessage, injectIntl, FormattedDate } from 'react-intl'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import {
	faHistory,
	faAlignJustify,
	faDownload
} from '@fortawesome/free-solid-svg-icons'

import { deviceTypeIcon } from '../../components/Utils'
import DetailsProperty from '../../components/DetailsProperty'
import ActionsMenu from '../../components/ActionsMenu'
import History from '../tracks/PlayHistory'
import DownloadHistory from '../../components/DownloadHistory'
import * as Auth from '../../auth'
import { isThirdPartyDeviceOnline } from '../../components/utils/thirdPartyDeviceUtils'
import S from '../../components/Styles'
import FormattedTimeSince from '../../utils/FormattedTimeSince'
import config from '../../config'
import { ThirdPartyDeviceDetailsQuery } from './Queries'
import gql from 'graphql-tag'
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons'
import { LocationPickerModal } from '../devices/LocationPicker'
import * as Utils from '../../components/Utils'

const vauxhallUrl = config.vauxhall.baseUrl
	.replace('https://', '')
	.replace('/', '')

class DeviceInfo extends Component {
	state = {
		historyModal: false,
		downloadHistoryModal: false,
		sshLoading: false,
		filePathModal: false,
		installDateLoading: false,
		locationPopup: false
	}

	render() {
		const { device, intl } = this.props
		let systemActions = []

		if (Auth.hasPermission('thirdPartyDevice:read:logs')) {
			systemActions.push({
				title: intl.formatMessage({
					id: 'thirdPartyDevices.info.actions.viewLogs'
				}),
				key: 'showLogs',
				icon: faAlignJustify,
				action: () =>
					window.open(
						`https://app.datadoghq.eu/logs?live=true&query_a=host%3A${vauxhallUrl}+%40uuid%3A${device.uuid}`,
						'_blank'
					)
			})
		}

		let logisticsActions = []
		if (Auth.hasPermission('thirdPartyDevice:edit:setLocation')) {
			logisticsActions.push({
				title: intl.formatMessage({
					id: 'thirdPartyDevices.info.setLocation'
				}),
				key: 'setLocation',
				icon: faLocationArrow,
				action: () => this.setState({ locationPopup: true })
			})
		}

		return (
			<div>
				<Row gutter={16}>
					<Col xs={24} md={12} style={S.mobileCol}>
						<Card
							title={intl.formatMessage({
								id: 'thirdPartyDevices.info.system'
							})}
							bodyStyle={S.card.body}
							extra={
								systemActions.length > 0 && (
									<ActionsMenu menuItems={systemActions} />
								)
							}
						>
							{Auth.hasPermission(
								'thirdPartyDevice:read:hostname'
							) && (
								<DetailsProperty title="thirdPartyDevices.info.hostname">
									{device.name}
								</DetailsProperty>
							)}
							{Auth.hasPermission(
								'thirdPartyDevice:read:model'
							) && (
								<DetailsProperty title="thirdPartyDevices.info.model">
									<Icon
										icon={deviceTypeIcon(device.OS)}
										style={styles.icon}
									/>
									&nbsp;
									{!!device.brand ? `${device.brand} ` : ''}
									{device.model}{' '}
									{device.simulator && (
										<FormattedMessage id="thirdPartyDevices.info.simulator" />
									)}
								</DetailsProperty>
							)}
							{Auth.hasPermission(
								'thirdPartyDevice:read:timeZone'
							) &&
								!!device.timeZone && (
									<DetailsProperty title="thirdPartyDevices.info.timeZone">
										{device.timeZone}
									</DetailsProperty>
								)}
							{Auth.hasPermission(
								'thirdPartyDevice:read:status'
							) &&
								isThirdPartyDeviceOnline(device) && (
									<DetailsProperty title="thirdPartyDevices.info.online">
										<FormattedMessage
											id="thirdPartyDevices.info.online.value"
											values={{
												date: (
													<FormattedDate
														value={
															device.onlineDate
														}
														year="numeric"
														month="short"
														day="2-digit"
														hour="2-digit"
														minute="2-digit"
													/>
												),
												relativeDate: (
													<FormattedTimeSince
														date={device.onlineDate}
													/>
												)
											}}
										/>
									</DetailsProperty>
								)}
							{Auth.hasPermission(
								'thirdPartyDevice:read:status'
							) &&
								!isThirdPartyDeviceOnline(device) && (
									<DetailsProperty title="thirdPartyDevices.info.online">
										<FormattedMessage
											id="thirdPartyDevices.info.offline.value"
											values={{
												date: (
													<FormattedDate
														value={
															device.onlineDate
														}
														year="numeric"
														month="short"
														day="2-digit"
														hour="2-digit"
														minute="2-digit"
													/>
												),
												relativeDate: (
													<FormattedTimeSince
														date={device.onlineDate}
													/>
												)
											}}
										/>
									</DetailsProperty>
								)}
						</Card>
					</Col>
					<Col xs={24} md={12} style={S.mobileCol}>
						{Auth.hasPermission(
							'thirdPartyDevice:read:history'
						) && (
							<Card
								title={intl.formatMessage({
									id: 'thirdPartyDevices.info.history'
								})}
								bodyStyle={{
									...S.card.body,
									paddingBottom: 10
								}}
							>
								<Button
									style={{ margin: 8 }}
									onClick={() =>
										this.setState({ historyModal: true })
									}
								>
									<Icon icon={faHistory} />
									&nbsp;
									<FormattedMessage id="thirdPartyDevices.info.actions.browseHistory" />
								</Button>
								{Auth.hasPermission(
									'thirdPartyDevice:read:fullHistory'
								) && (
									<Button
										style={{ margin: 8 }}
										onClick={() =>
											this.setState({
												downloadHistoryModal: true
											})
										}
									>
										<Icon icon={faDownload} />
										&nbsp;
										<FormattedMessage id="thirdPartyDevices.info.actions.downloadHistory" />
									</Button>
								)}
							</Card>
						)}
						<Card
							title={intl.formatMessage({
								id: 'thirdPartyDevices.info.logistics'
							})}
							bodyStyle={S.card.body}
							style={{ marginTop: 20 }}
							extra={<ActionsMenu menuItems={logisticsActions} />}
						>
							{Auth.hasPermission(
								'thirdPartyDevice:read:creationDate'
							) &&
								!!device.created && (
									<DetailsProperty title="thirdPartyDevices.info.creationDate">
										<FormattedDate
											value={device.created}
											year="numeric"
											month="short"
											day="2-digit"
										/>
									</DetailsProperty>
								)}

							{Auth.hasPermission(
								'thirdPartyDevice:read:location'
							) && (
								<DetailsProperty
									title="thirdPartyDevices.info.location"
									onClick={() => {
										if (
											Auth.hasPermission(
												'thirdPartyDevice:edit:setLocation'
											)
										) {
											this.setState({
												locationPopup: true
											})
										}
									}}
								>
									{(
										device.location?.address ||
										device.location?.additionalInfos
									) ?
										<React.Fragment>
											<div>{device.location.address}</div>
											<div
												style={{
													whiteSpace: 'pre-line'
												}}
											>
												{
													device.location
														.additionalInfos
												}
											</div>
										</React.Fragment>
									:	<FormattedMessage id="undefined" />}
								</DetailsProperty>
							)}

							<LocationPickerModal
								value={device.location}
								visible={this.state.locationPopup}
								title={this.props.intl.formatMessage({
									id: 'thirdPartyDevices.info.setLocation'
								})}
								onCancel={() =>
									this.setState({ locationPopup: false })
								}
								onChange={async (location) => {
									try {
										await this.props.client.mutate({
											variables: {
												id: device._id,
												location
											},
											mutation: gql`
												mutation updateThirdPartyDeviceLocation(
													$id: MongoID!
													$location: UpdateByIdThirdPartyDeviceLocationInput
												) {
													thirdPartyDeviceUpdateById(
														_id: $id
														record: {
															location: $location
														}
													) {
														recordId
													}
												}
											`,
											refetchQueries: [
												{
													query: ThirdPartyDeviceDetailsQuery,
													variables: {
														id: device._id
													}
												}
											],
											awaitRefetchQueries: true
										})
									} catch (e) {
										Utils.displayError(e)
									} finally {
										this.setState({ locationPopup: false })
									}
								}}
							></LocationPickerModal>
						</Card>
					</Col>
				</Row>
				{this.state.historyModal && (
					<History
						device={device}
						onClose={() => this.setState({ historyModal: false })}
					/>
				)}
				{this.state.downloadHistoryModal && (
					<DownloadHistory
						device={device}
						exportPath="/export_third_party_history"
						onClose={() =>
							this.setState({ downloadHistoryModal: false })
						}
					/>
				)}
			</div>
		)
	}
}

const styles = {
	icon: {
		width: 16
	},
	networkTitle: {
		width: '100%',
		textAlign: 'center',
		textTransform: 'uppercase',
		marginBottom: 10
	},
	lineItem: {
		marginBottom: 10
	}
}

export default withApollo(injectIntl(DeviceInfo))
